import { AuthSession } from '../../domain/entities/auth-session.entity';
import { AppRole } from '../../domain/enums/app-role.enum';

export interface AuthApiResponse {
  accessToken: {
    token: string;
    expiresInSeconds: number;
  };
  refreshToken: string;
  userId: string;
  userName: string | null;
  email: string | null;
  phone: string | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  isTemporalPassword: boolean;
  roles?: number[];
  permissions?: string[];
  clientId?: string | null;
}

export class AuthMapper {
  static toDomain(response: AuthApiResponse): AuthSession {
    return {
      accessToken: {
        token: response.accessToken.token,
        expiresInSeconds: response.accessToken.expiresInSeconds,
      },
      refreshToken: response.refreshToken,
      user: {
        userId: response.userId,
        userName: response.userName ?? '',
        email: response.email,
        phone: response.phone,
        firstName: response.firstName,
        lastName: response.lastName,
        fullName: response.fullName,
        isTemporalPassword: response.isTemporalPassword,
        roles: (response.roles ?? []) as AppRole[],
        permissions: response.permissions ?? [],
        clientId: response.clientId ?? null,
      },
    };
  }
}
